// ── MAINTENANCE MODE ─────────────────────────────────────────────────────────
// Maintenance config — managed via Admin Panel (stored in Supabase table g17_config)
// Quem importa estas variáveis sempre lê o valor atual (ligação "viva" do import ES),
// mas só este módulo pode reatribuí-las — por isso os setters abaixo.
export let _maintenanceMode    = false;
export let _maintenanceMessage = "Estamos fazendo melhorias no G17.\nVoltamos em breve!";
export let _maintenanceEta     = "Em breve";

export function setMaintenanceMode(v)    { _maintenanceMode = v; }
export function setMaintenanceMessage(v) { _maintenanceMessage = v; }
export function setMaintenanceEta(v)     { _maintenanceEta = v; }
